import React from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationVariant } from 'src/js/notification/notification';
import { createAndDispatchNotification } from 'src/js/notification/notification-helper';
import { LicenseViewModel } from 'src/js/pages/settings/license/license-view-model';

import { deleteLicense } from './license-store';
import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';

interface Props {
  licensesToDelete: LicenseViewModel[];
  onDeleteCompleted?: (failed: boolean) => void;
  onCancel?: VoidFunction;
}

export const LicenseDeleteModal: React.FunctionComponent<Props> = ({
  licensesToDelete,
  onDeleteCompleted,
  onCancel,
}) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    return Promise.all(licensesToDelete.map((e) => deleteLicense(e))).then((responses) => {
      const failed = responses.filter((r) => !r.ok);
      if (failed.length > 0) {
        createAndDispatchNotification(
          t('settings.licensing.notifications.deleteErrorMsg', { count: failed.length }),
          NotificationVariant.ERROR,
          t,
        );
      }
      onDeleteCompleted?.(failed.length > 0);
      return responses;
    });
  };

  return (
    <GenericDeleteModal
      title={t('settings.licensing.modal.delete.title', { count: licensesToDelete.length })}
      body={`${t('settings.licensing.modal.delete.bodyText')} ${t('general.cannotUndo')}`}
      onCancel={onCancel}
      onDelete={handleDelete}
      itemsToDelete={licensesToDelete}
    />
  );
};
